/**
 * AB Vault customer-portal config — mirrors `spotter/config.ts`'s "not hardcoded inline for
 * no reason" home for anything that varies per-instance in this interface.
 */

/** Header wordmark next to `AbLogo` — the PRODUCT name ("Vault"), not the company name (already
 *  baked into the logo image itself, `ab_logo_wht.png`'s "AMERICAN BRIDGE" lockup) — same
 *  logo-is-company / wordmark-is-product split as `SpotterHeader`'s `SpotterMark` icon + "Spotter"
 *  text. Now the same string as the browser tab title (`AB_VAULT_TITLE`, set in `AbHeader.tsx`),
 *  which used to be the company name but was changed to match this wordmark. */
export const AB_WORDMARK = "Vault";

/** The `requirePlugin(interfaceId)` string `apps/customer-api/src/routes/index.ts` gates every
 *  `/api/ab-vault-candidate-assignments/*` route with, and the same id `GET /api/context`'s
 *  `enabledInterfaces` carries — MUST stay in sync (no shared package between the two apps to
 *  import it from). Feeds `useInterfaceAccess`, the single "is this org actually entitled to AB
 *  Vault" check `AbHeader`/`CandidateAssignmentsScreen` use. */
export const AB_VAULT_INTERFACE_ID = "ab-vault-candidate-assignments";

/** The Vault tools. Each is gated by its OPEN custom action's ACL Teams; `GET /user/info` returns
 *  the ones this user may use. Must match `tools` in customer-api's `vaultToolAccess.ts`. */
export type VaultTool = "candidates" | "placeholder" | "upload";

/** Top-level nav tabs. `key` is the tab's route, and each tab is one tool, shown only to users the
 *  API allows it for (`visibleTabs`). */
export interface AbTab {
  key: string;
  label: string;
  tool: VaultTool;
}

/** The one Placeholders route; `?mode=bulk` picks the CSV mode over the single form. */
export const PLACEHOLDERS_PATH = "/ab-vault/placeholders";
export const BULK_MODE = "bulk";

export const AB_TOP_TABS: readonly AbTab[] = [
  { key: PLACEHOLDERS_PATH, label: "Placeholders", tool: "placeholder" },
  { key: "/ab-vault/upload", label: "Upload", tool: "upload" },
  {
    key: "/ab-vault/candidate-assignments",
    label: "Candidate Assignment",
    tool: "candidates",
  },
];

/** Tabs the user may use. */
export const visibleTabs = (tools: readonly VaultTool[]): AbTab[] =>
  AB_TOP_TABS.filter((t) => tools.includes(t.tool));
